<template>
  <div class="ui left aligned container">
    <div class="right floated">
      <button @click="percent=50;vote=true" class="ui small icon button">兑换</button>
      <button @click="percent=100;modal=true" class="ui small icon button">投币</button>
      <button @click="refresh()" class="ui small icon button"><i class="sync icon"></i></button>
    </div>
    <div>
      喵币：{{coins}} <span class="ui label"></span>  经验值：{{exp}}
    </div>
    <vuetable ref="vuetable"
              api-url="/mm/cats"
              :fields="fields"
              dataPath=""
              @vuetable:loaded="loaded"
              @vuetable:pagination-data="onPaginationData">
      <template slot="lock" scope="props">
        <div class="ui toggle checkbox" data-tooltip="禁止一键兑换经验值">
          <input type="checkbox" v-model="props.rowData.locked" @click="lock(props.rowData)">
          <label></label>
        </div>
      </template>
      <template slot="actions" scope="props">
        <i class="trash alternate outline link icon" title="解除绑定" @click="unbind(props.rowData.id)"></i>
      </template>
    </vuetable>

    <template v-if="!total">
      <div class="ui info message" v-if="show">
        <i class="close icon" @click="changeShow(false)"></i>
        <div class="header">如何找到你的账号</div>
        <ul class="list">
          <li>在<router-link to="/mm/users">用户列表</router-link>搜索微信昵称，通过头像确定你的账号。</li>
          <li>如果找不到，去微信小程序给杨超越投币。然后去<router-link to="/mm/stars/5644764907">本周投币列表</router-link>寻找。</li>
        </ul>
        <div class="ui divider"></div>
        <div class="header">申请绑定账号</div>
        <p>在账号详情页面点击<button class="ui tiny compact button">申请绑定</button>，填写你的微信号，等待管理员验证。
        </p>
      </div>
      <i class="ui info circle link icon" @click="changeShow(true)" v-else></i>
    </template>

    <Modal v-model="modal" title="一键投币">
      <form class="ui form">
        <div class="field">
          喵币：{{coins}}
        </div>
        <div class="required field">
          <label>喵币比例</label>
          <div class="ui right labeled input">
            <input name="name" type="number" min="1" max="100" v-model="percent">
            <div class="ui basic label">%</div>
          </div>
        </div>
      </form>
      <template slot="actions">
        <div @click="modal=false" class="ui cancel button">取消</div>
        <div @click="give" class="ui primary button" :disabled="percent<=0">投币</div>
      </template>
    </Modal>

    <Modal v-model="vote" title="一键兑换经验值">
      <form class="ui form">
        <div class="required field">
          <label>兑换经验值比例</label>
          <div class="ui right labeled input">
            <input name="name" type="number" min="1" max="100" v-model="percent">
            <div class="ui basic label">%</div>
          </div>
        </div>
        <div class="required field">
          <label>保留经验值</label>
          <input name="name" type="number" min="0" v-model="reserve">
        </div>
      </form>
      <template slot="actions">
        <div @click="vote=false" class="ui cancel button">取消</div>
        <div @click="exchange" class="ui negative button" :disabled="percent<=0">兑换</div>
      </template>
    </Modal>

  </div>
</template>

<script>
import axios from 'axios'
import Vuetable from '@/table/Vuetable'
import Modal from '@/components/Modal'

export default {
  name: 'CatList',
  components: {
    Vuetable,
    Modal,
  },
  data () {
    return {
      total: 0,
      coins: 0,
      exp: 0,
      percent: 100,
      reserve: 100,
      modal: false,
      vote: false,
      show: localStorage.getItem('cat_list_help') !== 'false',
      fields: [
        { name: '__sequence', title: '#' },
        //{ name: 'id', title: 'ID', callback: 'link', sortField: 'id' },
        { name: 'name', title: '昵称', callback: 'link', sortField: 'name' },
        { name: 'avatar', title: '头像', callback: 'avatar' },
        { name: 'coins', title: '喵币', sortField: 'coins' },
        { name: 'exp', title: '经验', sortField: 'exp' },
        { name: '__slot:lock', title: '锁定兑换' },
        { name: 'delegated', title: '托管', sortField: 'delegated' },
        { name: 'tasks', title: '任务数', sortField: 'tasks' },
        { name: 'date', title: '任务日期', sortField: 'date' },
        { name: 'starid', title: '明星ID', callback: 'star' },
        { name: '__slot:actions', title: '操作' },
      ],
      page: 0,
    }
  },
  methods: {
    onPaginationData (paginationData) {
      this.total = paginationData.length
    },
    loaded(data) {
      let coins = 0
      let exp = 0
      if (data) {
        for (let item of data) {
          coins += item.coins
          exp += item.exp
        }
        console.log(coins)
        console.log(exp)
      }
      this.coins = coins
      this.exp = exp
    },
    refresh () {
      this.$refs.vuetable.reload()
    },
    avatar (val, item) {
      return '<a href="/#/mm/users/' + item.id + '"><img class="ui tiny image" src="' + val + '"></a>'
    },
    link (val, item) {
      return '<a href="/#/mm/users/' + item.id + '">' + val + '</a>'
    },
    star (val) {
      return '<a href="/#/mm/stars/' + val + '">' + val + '</a>'
    },
    changeShow(show) {
      this.show = show
      localStorage.setItem('cat_list_help', show+'')
    },
    lock(row) {
      axios.post('/mm/lock?openid=' + row.id).then(({data}) => {
        row.locked = data
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
    unbind(openid) {
      axios.delete('/mm/bind?openid=' + openid).then(() => {
        this.refresh()
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
    give () {
      axios.post('/mm/give?percent=' + this.percent).then(({ data }) => {
        if (data.status === 0) {
          this.$toasted.success(data.data.length + '人成功投币')
        } else {
          this.$toasted.error(data.message)
        }
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
    exchange () {
      axios.post('/mm/exchange?percent=' + this.percent + '&reserve=' + this.reserve).then(({ data }) => {
        if (data.status === 0) {
          this.$toasted.success(data.data.length + '人成功兑换')
        } else {
          this.$toasted.error(data.message)
        }
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
  }
}
</script>

<style scoped>
.right.floated {
  float: right;
  margin-top: -50px;
}
.info.icon {
  float: right;
  margin-top: 24px;
  margin-right: 6px;
}
</style>
